<template>
    <header>
        <div class="title">
            {{ title || $t('header.untitled_page') }}
        </div>
        <slot />
    </header>
</template>

<script>
export default {
    name: 'AppHeader',
    props: {
        title: {
            type: String,
            default: null
        }
    }
}
</script>

<style lang="scss" scoped>
header {
    height: 60px;
    display: grid;
    grid-template-columns: 1fr auto auto auto;
    grid-gap: 10px;
    padding: 0px 25px;
    align-items: center;
    z-index: 1000;
    border-bottom: 1px solid rgba(0,0,0,0.07);

    & .title {
        font-size: 18px;
    }
}
</style>
